<template>
  <div>
    <b-row v-if="$lang.book_and_article">
      <b-col cols="12" md="12">
        <b-alert show variant="info" class="font-weight-bold">
          <i class="fas fa-info-circle fa-lg mr-2" />
          <span class="lh_30" v-text="$lang.book_and_article" />
        </b-alert>
      </b-col>
    </b-row>
    <Search
      v-if="url"
      :filterCatch="false"
      :allowCollapse="false"
      :url="url"
      :title="$lang.article"
      config="searchPartner"
      :allowFields="$lang.search_articles"
      addModalSize="lg"
      removeModalSize="xl"
      :visibleSearch="false"
      :visibleSettings="false"
      :visibleExport="false"
      :visibleFilters="false"
      :visibleViewCount="false"
      :allowEdit="false"
      :toggleable="true"
      :defaultViewCount="10"
      :visibleAccordion="true"
      ref="searchArticels"
      :dynamicButtons="buttons"
      :parentPermissions="permissions"
      @getPermisson="updatePermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddAricles :code="code" @close="search.close" @getData="getData" />
      </template>
    </Search>
    <b-modal
      :title="$lang.search.columns_setting"
      variant="primary"
      content-class="border-primary"
      size="xl"
      v-model="modalNewColumn"
      :ok-title="$lang.submitButton"
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <EditAricles
        :itemId="itemId"
        :code="code"
        @cancel="cancel"
        @getData="getData"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddAricles from "./addAricles";
import EditAricles from "./editAricles.vue";
import { pathOr } from "ramda";
import { generateApiUrl, isAdmin } from "@/shared/utils";

export default {
  name: "search-articles",
  components: {
    Search,
    AddAricles,
    EditAricles,
  },
  props: {
    code: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      permissions: [],
      itemId: null,
      modalNewColumn: false,
      buttons: [
        {
          id: 0,
          name: "edit",
          click: this.changeEdit,
        },
        {
          id: "1",
          name: "view",
          click: this.changeEdit,
        },

        {
          id: "3",
          name: "delete",
        },
      ],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["profile", "person_article"], [this.code]);
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    isAdmin,
    cancel() {
      this.modalNewColumn = false;
    },
    getData() {
      this.$refs.searchArticels.getItems();
      this.modalNewColumn = false;
    },
    changeEdit(item) {
      this.itemId = pathOr(null, ["id"], item);
      this.modalNewColumn = true;
    },
    updatePermissions(permissions) {
      this.permissions = permissions;
      this.$emit("getPermissions", permissions);
    },
  },
};
</script>
